import zeusSdk from '_/utils/SDKs';

export interface PublicToken {
  id?: string;
  name: string;
  token?: string;
  editor?: any;
  [key: string]: any;
}

/**
 * Fetch all public tokens for the organization
 */
export const fetchPublicTokens = async (): Promise<PublicToken[]> => {
  try {
    const response = await zeusSdk.publicTokens.list({ include: 'editor' });
    return response?.items || [];
  } catch (error) {
    console.error('Error fetching organization public tokens', error);
    return [];
  }
};

/**
 * Create a new public token
 */
export const createPublicToken = async (publicToken: { name: string }): Promise<PublicToken> => {
  return zeusSdk.publicTokens.create(publicToken);
};

/**
 * Update an existing public token
 */
export const updatePublicToken = async (publicTokenId: string, publicToken: Partial<PublicToken>): Promise<PublicToken> => {
  return zeusSdk.publicTokens.patch(publicTokenId, publicToken);
};

/**
 * Delete a public token
 */
export const deletePublicToken = async (publicTokenId: string): Promise<void> => {
  return zeusSdk.publicTokens.delete(publicTokenId);
};

/**
 * Copy text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
  } else {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
    document.body.removeChild(textArea);
  }
};
